/**
 * 图片预览
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import { Popover} from 'antd';
import LazyLoad from 'react-lazy-load';
import PropTypes from "prop-types";
import "./Index.less";

class ImageHover extends React.Component{
    static propTypes ={
        src:PropTypes.string.isRequired,
    }
    static defaultProps = {
        src: '',
        size:0,
        height:280
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }
    componentDidMount() {
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { src, size,height} =this.props;
        return (
            <Popover placement="right" arrow={true} content={
                <div className={'popImage'}> <img src={src+'@!600'} alt=""/> </div>
            }>
                <div>
                    <LazyLoad height={height}>
                        <img src={src+(size?"@!"+size:"")} className="img" alt=""/>
                    </LazyLoad>
                </div>

                {/*<img src={src+(size?"@!"+size:"")} className="img" alt=""/>*/}
            </Popover>
     )
    }
}

export default ImageHover;
